import { render, staticRenderFns } from "./RealEstateListingsListItem.vue?vue&type=template&id=a1bc06d8"
import script from "./RealEstateListingsListItem.vue?vue&type=script&lang=ts"
export * from "./RealEstateListingsListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports